module.exports = __webpack_public_path__ + "static/background-8390f33c60c03216eed907817f81a50b.jpg";